import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import UserItem from '../components/UserItem';
import { CircularProgress } from '@mui/material';

function StalkingList() {
  const { userId } = useParams(); // Get user ID from URL
  const navigate = useNavigate();
  const [stalking, setStalking] = useState([]); // Ensure it's initialized as an empty array
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStalking = async () => {
      try {
        const res = await axiosInstance.get(`/profile/${userId}/stalking`);
        setStalking(res.data || []); // Fallback to empty array
        setLoading(false);
      } catch (err) {
        console.error('Error fetching stalking:', err);
        setLoading(false);
      }
    };

    fetchStalking();
  }, [userId]);

  if (loading) {
    return  <div className="loading-container">
              <CircularProgress size={40} sx={{ color: 'black' }} />
            </div>;
  }

  return (
    <div>
      <div className="top-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 className="top-title">Stalking</h1>
      </div>

      {stalking.length > 0 ? (
        stalking.map((user) => (
          <UserItem
            key={user.user_id}
            user={user}
            navigate={navigate}
          />
        ))
      ) : (
        <p>No stalking found.</p>
      )}
    </div>
  );
}

export default StalkingList;
